import { ACTIVE_DIRECTORY_ACCOUNT_TYPE } from 'pages/service-account-creation/constant';

export const getServiceAccountCreationPayload = ({ order, isSQLServer }) => {
    const trim = (val) => (typeof val === 'string' ? val.trim() : val);
    const payload = {
        applicationName: trim(order?.applicationName),
        accountOwnerId: trim(order?.appOwnerDetails?.gpid || order?.accountOwnerId),
        applicationOwnerId: trim(order?.applicationOwnerDetails?.gpid || order?.applicationOwnerId),
        environment: trim(order?.environment),
        sector: trim(order?.sector),
        applicationService: trim(order?.applicationServiceCI),
        accountType: trim(order?.accountType),
        applicationShortName: trim(order?.appShortName),
    };

    if (isSQLServer) payload.sqlServerName = trim(order?.sqlServerDetails?.gpid || order?.sqlServerName);

    if (order?.accountType === ACTIVE_DIRECTORY_ACCOUNT_TYPE && order?.selectedPamSafe) {
        payload.myPamSafeName = order.selectedPamSafe;
    }

    return payload;
};

export const getServiceAccountResubmitPayload = ({ order }) => {
    const payload = {
        applicationName: order?.applicationName,
        accountOwnerId: order?.appOwnerDetails?.gpid || order?.accountOwnerId,
        applicationOwnerId: order?.applicationOwnerDetails?.gpid || order?.applicationOwnerId,
        environment: order?.environment,
        sector: order?.sector,
        applicationService: order?.applicationServiceCI,
        accountType: order?.accountType,
        applicationShortName: order?.appShortName,
    };

    if (order?.accountType === ACTIVE_DIRECTORY_ACCOUNT_TYPE && order?.selectedPamSafe) {
        payload.myPamSafeName = [order.selectedPamSafe];
    }

    return payload;
};

export const formOrderObjFromOrderDetails = (data = null) => {
    if (data?.catalogServices?.[0]?.catalogConfig) {
        const response = data?.catalogServices?.[0]?.catalogConfig;

        return {
            accountType: response?.accountType,
            applicationName: response?.applicationName,
            accountOwnerId: response?.accountOwnerId,
            applicationOwnerId: response?.applicationOwnerId,
            sector: response?.sector,
            environment: response?.environment,
            appOwner: null,
            appOwnerDetails: { name: response?.accountOwner, gpid: response?.accountOwnerId },
            applicationOwner: null,
            applicationOwnerDetails: { name: response?.applicationOwner, gpid: response?.applicationOwnerId },
            sqlServerName: response?.sqlServerName,
            applicationServiceCI: response?.applicationService,
            appShortName: response?.applicationShortName,
            isTouched: false,
            selectedPamSafe: response?.myPamSafeName?.[0] || null,
        };
    }
    return null;
};
